module.exports = __webpack_public_path__ + "static/WAS-logo-abe4ccf44f9ce85e93672c2a8ef51a75.png";